"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.173 4.51a.19.19 0 0 0-.346 0L9.74 8.923a.7.7 0 0 1-.54.395l-4.632.613a.195.195 0 0 0-.115.325l3.333 3.619a.7.7 0 0 1 .173.602l-.91 4.89c-.03.16.136.278.274.209l4.362-2.2a.7.7 0 0 1 .63 0l4.362 2.2a.192.192 0 0 0 .274-.21l-.91-4.89a.7.7 0 0 1 .174-.601l3.333-3.62a.195.195 0 0 0-.116-.324l-4.63-.613a.7.7 0 0 1-.542-.395zm-1.611-.599c.574-1.216 2.302-1.216 2.877 0l1.924 4.07 4.253.563c1.281.17 1.834 1.714.961 2.661l-3.095 3.361.846 4.545c.24 1.292-1.101 2.31-2.281 1.716L12 18.787l-4.047 2.04c-1.18.595-2.52-.424-2.28-1.716l.845-4.545-3.095-3.36c-.873-.948-.32-2.492.961-2.662l4.253-.563z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StarOutlineIcon24.js.map